import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewBonusWalletApi } from 'src/app/shared/apis/new-bonus-wallet.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialogRef } from 'src/app/shared/service/connected-dialog';

@Component({
  selector: 'app-locked-bonuses',
  standalone: true,
  imports: [CSIconButtonComponent, CSButtonComponent, PipesModule, LoadingModule],
  templateUrl: './locked-bonuses.component.html',
  styleUrl: './locked-bonuses.component.scss',
})
export class LockedBonusesComponent implements OnInit {
  loading: boolean = false;
  lockedBonusAmountDetail: any;
  constructor(
    private newBonusWalletApi: NewBonusWalletApi,
    private dialogRef: MatConnectedDialogRef<LockedBonusesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { lockedBonusAmount: number; lockedBonusAmountDetail: any },
  ) {}
  ngOnInit(): void {
    this.loading = true;
    this.newBonusWalletApi.getActiveBonusBalanceByCurrency().subscribe(res => {
      this.loading = false;
      if (res) {
        this.lockedBonusAmountDetail = res;
      }
    });
  }
  close() {
    this.dialogRef.close();
  }
}
